import { render, staticRenderFns } from "./Facts.vue?vue&type=template&id=9e11e498&scoped=true&"
import script from "./Facts.vue?vue&type=script&lang=js&"
export * from "./Facts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e11e498",
  null
  
)

export default component.exports